const PIXEL_ID = "1325566242487652";
const SCRIPT_SRC = "https://connect.facebook.net/en_US/fbevents.js";

let scriptPromise = null;
const trackedPaths = new Set();

function ensureFbqStub() {
  if (typeof window === "undefined" || window.fbq) return;

  const fbq = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];

  window.fbq = fbq;
  window._fbq = fbq;
}

function loadScript() {
  if (typeof document === "undefined") return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
    scriptPromise = Promise.resolve();
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = SCRIPT_SRC;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Meta Pixel script."));
    document.head.appendChild(script);
  });

  return scriptPromise;
}

async function ensureMetaPixel() {
  if (typeof window === "undefined") return;

  ensureFbqStub();
  await loadScript();

  if (!window.fbq.__einviteInitialized) {
    window.fbq("init", PIXEL_ID);
    window.fbq.__einviteInitialized = true;
  }
}

export async function trackMetaPixelPageView() {
  if (typeof window === "undefined") return;

  const path = `${window.location.pathname}${window.location.search}`;
  if (trackedPaths.has(path)) return;
  trackedPaths.add(path);

  try {
    await ensureMetaPixel();
    window.fbq?.("track", "PageView");
  } catch {
    // Analytics should never block the page.
  }
}

